import { listCommissions, createCommission, updateCommission, deleteCommission } from '@/services/academy/commissions.service'

export default {
	namespaced: true,
	state: {
		list:       { data: [], meta: { total: 0 } },
		listStatus: 'init',
	},
	getters: {
		getList:       (s) => s.list,
		getListStatus: (s) => s.listStatus,
	},
	mutations: {
		SET_LIST(state, v)        { state.list = v },
		SET_LIST_STATUS(state, v) { state.listStatus = v },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await listCommissions(params)
				commit('SET_LIST', data)
				commit('SET_LIST_STATUS', 'init')
			} catch {
				commit('SET_LIST_STATUS', 'error')
			}
		},
		async create({ dispatch }, data) {
			await createCommission(data)
			dispatch('fetchList')
		},
		async update({ dispatch }, data) {
			await updateCommission(data)
			dispatch('fetchList')
		},
		async remove({ dispatch }, id) {
			await deleteCommission(id)
			dispatch('fetchList')
		},
	},
}
